import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ClientFeatureOptions } from '@uc/web/shared/data-models';
import { ClearingUniversityCardComponent } from '@web/shared/ui';
import { CourseDetails } from '../../../models/course-search.models';
import { ClearingCourseCardContainerComponent } from '../clearing-course-card-container/clearing-course-card-container.component';
import { ProductEnum } from '@uc/shared/data-models';
import { NA } from '@uc/web/core';

@Component({
	selector: 'uc-course-list-clearing-uni',
	standalone: true,
	templateUrl: './course-list-clearing-uni.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ClearingUniversityCardComponent, ClearingCourseCardContainerComponent],
})
export class CourseListClearingUniComponent {
	searchTerm = input.required<string>();
	courses = input.required<CourseDetails[]>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	uniId = input.required<number>();
	uniLogo = input.required<string>();
	uniCoverImage = input.required<string>();
	cleSearchOrderPosition = input.required<number>();
	externalUrl = input.required<string>();
	uniPhoneNumber = input.required<string>();
	clientFeatures = input.required<ClientFeatureOptions[]>();
	isFavourite = input.required<boolean>();
	recommendedPercentage = input.required<number>();
	privacyPolicyUrl = input.required<string | null>();

	readonly clearing = ProductEnum.Clearing;
	readonly na = NA;
}
